import { CategoryConfig } from '../../../types';
import { inMemoryRecipes } from './inMemoryRecipes';

const initialCategories: Record<number, CategoryConfig> = {};
export const inMemoryCategories: CategoryConfig[] = Object.values(
  inMemoryRecipes
    .flatMap((recipe) => recipe.categories)
    .reduce((categories, currentCategory) => {
      const existing = categories[currentCategory.id];
      if (existing) {
        existing.recipesCount++;
      } else {
        categories[currentCategory.id] = { ...currentCategory, recipesCount: 1 };
      }
      return categories;
    }, initialCategories)
).sort((a, b) => b.recipesCount - a.recipesCount);
